import React, { useEffect, useState } from "react";
import useLocales from "../../hooks/useLocales";
import { useCookies } from "react-cookie";
import CookiesPreferenceConfirmModal from "./CookiesPreferenceConfirmModal";

const ConsentCookies = () => {
  const { translate } = useLocales();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [showConsentBanner, setShowConsentBanner] = useState(false);

  useEffect(() => {
    if (cookies.cookieConsent === undefined) {
      setShowConsentBanner(true);
    }
  }, [cookies.cookieConsent]);

  const handleAcceptAll = () => {
    setCookie("cookieConsent", "accepted", {
      path: "/",
      expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    }); // Expires in 30 days
    setShowConsentBanner(false);
  };

  const handleRejectAll = () => {
    setCookie("cookieConsent", "rejected", {
      path: "/",
      expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    }); // Expires in 30 days
    setShowConsentBanner(false);
  };

  const handleCustomize = () => {
    // setCookie("cookieConsent", "customized", {
    //   path: "/",
    //   expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    // }); // Expires in 30 days
    setIsModalOpen(true);
    setShowConsentBanner(false);
  };

  return (
    <>
      {showConsentBanner && (
        <section
          className="fixed bottom-0 w-full bg-[#FFFFFF] dark:bg-dark-primary"
          style={{ zIndex: "99" }}
        >
          <div className="container px-[20px] lg:px-20 py-4 mx-auto lg:flex lg:items-center lg:gap-x-16">
            <div>
              <h4 className="mb-4 text-2xl font-bold text-gray-800 dark:text-color_v1_dark">
                {translate("we_use_cookies")}
              </h4>
              <div className="container mx-auto lg:flex lg:items-center lg:gap-x-16 ">
                <p className="text-gray-600 dark:text-color_v2_dark">
                  {translate("we_use_cookies_and_other_technologies")}
                </p>

                <div className="flex flex-col items-center mt-4 md:flex-row md:gap-x-4 shrink-0 md:mt-4 lg:mt-0">
                  <button
                    className="w-full px-6 py-2 mb-2 text-base font-medium text-gray-900 dark:text-color_v1_dark bg-white dark:bg-dark-primary border-black dark:border-color_v2_dark rounded-full md:w-auto border-1 md:mb-0"
                    onClick={handleCustomize}
                  >
                    {translate("customize")}
                  </button>
                  <button
                    className="w-full px-6 py-2 mb-2 text-base font-medium text-gray-900 dark:text-color_v1_dark bg-white dark:bg-dark-primary border-black dark:border-color_v2_dark rounded-full md:w-auto border-1 md:mb-0"
                    onClick={handleRejectAll}
                  >
                    {translate("reject_all")}
                  </button>
                  <button
                    className="w-full px-6 py-2 text-base font-medium text-white bg-red-500 rounded-full md:w-auto"
                    onClick={handleAcceptAll}
                  >
                    {translate("accept_all")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <CookiesPreferenceConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default ConsentCookies;
